import translations from '../../translations';
import TranslationExport from './TranslationExport';
import TranslationImport from './TranslationImport';

interface Props {
    container: HTMLElement | null | undefined;
    setIsProcessing: (isProcessing: boolean) => void;
}

const TranslationBase = ({ container, setIsProcessing }: Props) => {
    return (
        <>
            <h2>{translations.TRANSLATIONS_main_header}</h2>
            <TranslationExport setIsProcessing={setIsProcessing} />
            <TranslationImport container={container} setIsProcessing={setIsProcessing} />
        </>
    );
};

export default TranslationBase;
